FroalaEditor.DefineIcon('peeristicsTemplateVariable', { NAME: 'cog'});

FroalaEditor.RegisterCommand('peeristicsTemplateVariable', {
    title: 'Template Symbols',
    type: 'dropdown',
    focus: false,
    undo: false,
    refreshAfterCallback: true,
    options: {
        'user.name': "User's Name",
        'user.email': "User's Email Address",
        'network.name': "Network's Name",
        'container.name': "Container's Name"
    },

    callback: function (cmd, val) {
        // Work to perform when a selection from the template list is made
        // value is the left hand of the options K-V above.
        this.selection.element().after('{{' + val + '}}')
    },

    // Callback on refresh.
    refresh: function (btn) {
        // Work performed when the editor is refreshed.
    },

    refreshOnShow: function (btn, dropdown) {
        // We attach context to the add resources modal, and this loads after the modal,
        // so we can cheat and pull the context from there instead of setting it again on
        // the individual content blocks.
        context = $('#modalAddResources').data('context-type')

        // For User context, we hide the {{container.name}} template.
        if (context == 'user') {
            dropdown.find('[data-param1="container.name"]').hide()
        }
    }
});
